import React, { Component, Fragment } from "react";
//import Cookies from "js-cookie";
import Theme from "../../assets/Theme";
import style from "./../../config/style.json";
import config from "./../../config/config.json";
import clsx from "clsx";
import {
  Toolbar,
  AppBar,
  Typography,
  IconButton,
  Container,
  Icon,
  Avatar,
  Collapse,
  Link,
  Alert,
  Button,
  Grid,
  TextField,
  CircularProgress,
} from "@mui/material";
import SidebarNavigation from "./partials/SidebarNavigation";
import MenuDropdown from "./partials/MenuDropdown";
import { Navigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../assets/images/logo-white.png";
import { Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { connect } from "react-redux";
import ProfileImageUploadModal from "./partials/ProfileImageUploadModal";
import { ENV } from "../../config/config.js"

class MainAdmin extends Component {
  constructor(props) {
    super(props);
    this.user = window.localStorage.getItem("user");
    this.state = {
      open: true,
      mode: "ADMIN",
      userData: {},
      statusLogin: false,
      cards: config.cards,
      responseForgot: "",
      openAlert: true,
      showSidebar: null,
      title: "",
      showHotelSelection: false,
      showSwitchAccount: false,
      listHotels: null,
      searchText: "",
      hasSelectedHotel: window.localStorage.getItem("selectedHotel"),
      redirectToHome: false,
      userDataApi: null,
      showSwitchAdmin: false,
      showAdmin: false,
      isAdmin: window.localStorage.getItem("isAdmin"),
      additionalUserData: {},
      sentListAccounts: false,
      sentUserUpdate: false,
      queryParams: {
        page_size: 1000,
      },
      showProfileModal: false,
    };
    this.environmentIdentifier = ENV;
  }

  validateToken = () => {
    try {
      const headersSetCookie = window.localStorage.getItem("headersSetCookie");
      if (!headersSetCookie) {
        this.logout();
        return;
      }

      const userDataJWT = jwtDecode(headersSetCookie);
      const now = Math.floor(Date.now() / 1000);

      if (userDataJWT.exp && now >= userDataJWT.exp) {
        this.logout();
      }
    } catch (error) {
      console.error("Error validating token:", error);
      this.logout();
    }
  };

  componentDidMount() {
    const headersSetCookie = window.localStorage.getItem("headersSetCookie");
    const additionalUserData = JSON.parse(
      window.localStorage.getItem("additionalUserData")
    );

    if (!headersSetCookie || !additionalUserData) {
      this.logout();
      return;
    }

    const userDataJWT = jwtDecode(headersSetCookie);
    const now = Math.floor(Date.now() / 1000);
    if (userDataJWT.exp && now >= userDataJWT.exp) {
      this.logout();
      return;
    }

    this.interval = setInterval(() => {
      this.validateToken();
    }, 60 * 1000);

    window.localStorage.setItem("userData", JSON.stringify(userDataJWT));
    if (!window.localStorage.getItem("firstLogin")) {
      window.localStorage.setItem(
        "firstLogin",
        JSON.stringify(userDataJWT.firstLogin)
      );
    }

    this.setState(
      {
        userDataApi: userDataJWT,
        additionalUserData,
      },
      () => {
        if (additionalUserData.roles?.includes("ROLE_SUPERUSER")) {
          const queryString = `?page_size=${this.state.queryParams.page_size}&include=subscription&originSystem=A2`;
          this.props.getAccountListFiltered(
            headersSetCookie,
            queryString,
            null,
            additionalUserData.uuid
          );
          this.setState({ sentListAccounts: true });
        } else {
          this.handleWebService(
            this.state.additionalUserData.permissionsByAccount
          );
        }
      }
    );
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.accountReducer.resultsAccountsListFiltered !==
      prevProps.accountReducer.resultsAccountsListFiltered &&
      this.props.accountReducer.resultsAccountsListFiltered != null &&
      this.state.sentListAccounts
    ) {
      const formattedHotels =
        this.props.accountReducer?.resultsAccountsListFiltered?.records
          ?.filter((hotel) => hotel.enabled === true)
          .map((hotel) => ({
            accountName: hotel.name,
            accountUuid: hotel.uuid,
            accountCurrency: hotel.currency || "",
            accountSubscriptionName: (hotel.subscription && hotel.subscription.name) || ""
          }));
      this.setState(
        { listHotels: formattedHotels, sentListAccounts: false },
        () => {
          this.handleWebService(this.state.listHotels, true);
        }
      );
    }
    if (this.props.usersReducer.resultsUserPatch !==
      prevProps.usersReducer.resultsUserPatch &&
      this.props.usersReducer.resultsUserPatch != null &&
      this.state.sentUserUpdate) {

      const updatedUserData = {
        ...this.state.additionalUserData,
        profilePictureUri: this.props.usersReducer?.resultsUserPatch?.profilePictureUri || null
      };

      window.localStorage.setItem(
        "additionalUserData",
        JSON.stringify(updatedUserData)
      );

      this.setState({
        additionalUserData: updatedUserData,
        showProfileModal: false,
        sentUserUpdate: false
      });
    }
  }

  logout() {
    this.user = null;
    window.localStorage.clear();
    this.setState({ userData: {}, additionalUserData: {} });
  }

  handleWebService = (accountsList, isSuperUser = false) => {
    try {
      const { userDataApi, hasSelectedHotel, isAdmin } = this.state;

      if (!userDataApi.accessToken) {
        this.logout();
        return;
      }

      let showHotels = false;
      let listHotels = null;
      let showSwitchAccount = false;
      let showAdmin = isSuperUser;
      let dataTitle = "Admin Panel";

      if (!hasSelectedHotel) {
        if (isAdmin) {
          dataTitle = "ADMIN";
        } else if (!accountsList || accountsList.length === 0) {
          window.localStorage.setItem("uuidSetCookie", userDataApi.uuid);
          window.localStorage.setItem("currencyAccount", "");
          window.localStorage.setItem("accountSubscriptionName", "");
        } else if (accountsList.length === 1) {
          const account = accountsList[0];
          window.localStorage.setItem("uuidSetCookie", account.accountUuid);
          window.localStorage.setItem("selectedHotel", account.accountName);
          window.localStorage.setItem("currencyAccount", account.accountCurrency || "");
          window.localStorage.setItem("accountSubscriptionName", account.accountSubscriptionName || "");
          dataTitle = account.accountName;
        } else {
          window.localStorage.setItem("uuidSetCookie",
            accountsList[0]?.accountUuid || userDataApi.uuid
          );
          window.localStorage.setItem("currencyAccount", "");
          window.localStorage.setItem("accountSubscriptionName", "");
          showHotels = true;
          listHotels = accountsList;
        }
      }

      if ((hasSelectedHotel && accountsList.length > 1) || isAdmin) {
        dataTitle = hasSelectedHotel || "ADMIN";
        showSwitchAccount = true;
        showAdmin = false;
      }
      if (hasSelectedHotel && accountsList.length === 1) {
        dataTitle = hasSelectedHotel
      }

      this.setState({
        userData: userDataApi,
        showSidebar: true,
        showHotelSelection: showHotels,
        title: dataTitle,
        mode: "ADMIN",
        listHotels,
        showSwitchAccount,
        showAdmin,
      });
    } catch {
      this.logout();
    }
  };

  handleSwitchAccount = () => {
    setTimeout(() => {
      window.localStorage.removeItem("selectedHotel");
      window.localStorage.removeItem("isAdmin");
      this.props.resetSagaAnalyticsHighlights();
      this.setState({ redirectToHome: true });
    }, 0);
  };

  handleSwitchAdmin = () => {
    const userDataString = window.localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    if (!userData || !userData.id) {
      this.logout();
      return;
    }
    setTimeout(() => {
      window.localStorage.removeItem("selectedHotel");
      window.localStorage.setItem("isAdmin", "true");
      window.localStorage.setItem("uuidSetCookie", this.state.userDataApi.uuid);
      window.localStorage.setItem("currencyAccount", "");
      window.localStorage.setItem("accountSubscriptionName", "");
      this.setState({
        showHotelSelection: false,
        showSidebar: true,
        title: "ADMIN",
        showSwitchAccount: true,
        showAdmin: false,
        redirectToHome: true,
      });
    }, 0);
  };

  handleHotelSelect = (hotel) => {
    const userDataString = window.localStorage.getItem("userData");
    const userData = userDataString ? JSON.parse(userDataString) : null;
    if (!userData || !userData.id) {
      this.logout();
      return;
    }
    window.localStorage.setItem("selectedHotel", hotel.accountName);
    window.localStorage.setItem("uuidSetCookie", hotel.accountUuid);
    window.localStorage.setItem("currencyAccount", hotel.accountCurrency);
    window.localStorage.setItem("accountSubscriptionName", hotel.accountSubscriptionName);
    window.localStorage.setItem("isAdmin", false);
    this.setState({
      showHotelSelection: false,
      showSidebar: true,
      title: hotel.accountName,
      showSwitchAccount: true,
      showAdmin: false,
    });
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  callbackCard = (indiceCard) => {
    this.state.cards.map((value, i) => {
      if (i === indiceCard) {
        value.expanded = true;
        value.visibility = true;
      } else {
        value.expanded = false;
        value.visibility = false;
      }
      return value;
    });

    this.setState({ cards: this.state.cards });
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };
  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  callbackForgot = (res) => {
    this.setState({ responseForgot: res });
  };

  collapseAlert = () => {
    this.setState({ openAlert: false });
  };

  handleAvatarClick = (e) => {
    e.stopPropagation(); // evita que se abra el menú del dropdown
    this.setState({ showProfileModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showProfileModal: false });
  };

  handleSaveProfileImage = (file) => {
    const headersSetCookie = window.localStorage.getItem("headersSetCookie");
    let form = {}
    form['profilePictureUri'] = file
    this.props.updateUser(headersSetCookie, form, this.state.userDataApi.uuid);
    this.setState({ sentUserUpdate: true });
  };

  render() {
    if (this.state.redirectToHome) {
      return <Navigate to="/" />; //  Perform the redirection
    }

    if (this.user === null) {
      return <Navigate to="/login" state={{ sessionExpired: true }} />;
    }

    if (this.state.showSidebar === null) {
      return (
        <Fragment>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(245, 245, 245, 0.6)",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
              zIndex: 1300,
            }}
          />
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: "20px",
              zIndex: 1400,
              pointerEvents: "none",
            }}
          >
            <CircularProgress
              size={60}
              thickness={4}
              style={{ color: "#135265" }}
            />
            <Typography variant="h6" style={{ color: "#424242" }}>
              Loading Travel Curious...
            </Typography>
          </div>
          <Theme isAdminMode={false}>
            <div
              className="wrapper MainLayout_wrapper environmentProduction navBarTopContainer"
              styles={style}
            >
              <AppBar position="absolute" className="appBar" sx={{ zIndex: 1 }}>
                <Toolbar className="toolbar_Appbar environmentProduction">
                  <Link href="/dashboard/">
                    <img
                      className="toolbarLogo"
                      src={Logo}
                      alt="Travel Curious"
                    />
                  </Link>
                </Toolbar>
              </AppBar>
            </div>
          </Theme>
        </Fragment>
      );
    }
    const isAdminMode =
      this.state.isAdmin === "true" || this.state.title === "ADMIN";
    return (
      <Fragment>
        <Theme isAdminMode={isAdminMode} >
          <div
            styles={style}
            className={
              this.environmentIdentifier === "andy"
                ? `wrapper MainLayout_wrapper environmentAndy navBarTopContainer`
                : `wrapper MainLayout_wrapper environmentProduction navBarTopContainer`
            }
          >
            {/* START HEADER */}
            <AppBar
              position="absolute"
              className={clsx("appBar", this.state.open && "appBarShift")}
            >
              <Toolbar
                className={
                  this.environmentIdentifier === "andy"
                    ? `toolbar_Appbar environmentAndy`
                    : `toolbar_Appbar environmentProduction`
                }
              >
                <Link href="/dashboard/">
                  <img
                    className={clsx(
                      "toolbarLogo",
                      this.state.open && "toolbarLogoShow"
                    )}
                    src={Logo}
                    alt="Travel Curious"
                  />
                </Link>
                <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  className="title_Dashboard"
                >
                  {this.state.title}
                </Typography>

                <div className="welcomeText">
                  Welcome back, {this.state.userData.name}
                </div>

                {Object.keys(this.state.userData).length > 0 ? (
                  <>
                    {this.state.showAdmin && (
                      <Button
                        className="transparentButton" // Apply the class
                        onClick={this.handleSwitchAdmin}
                      >
                        ADMIN
                      </Button>
                    )}

                    {this.state.showSwitchAccount && (
                      <Button
                        className="transparentButton" // Apply the class
                        onClick={this.handleSwitchAccount}
                      >
                        Switch Account
                      </Button>
                    )}

                    <Avatar
                      className="MenuHeader_Avatar"
                      onClick={this.handleAvatarClick}
                      style={{
                        cursor: 'pointer',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        objectFit: 'cover',
                      }}
                      src={this.state.additionalUserData?.profilePictureUri || undefined}
                    >
                      {!this.state.additionalUserData?.profilePictureUri && (
                        <Icon className="material-symbols-outlined">person</Icon>
                      )}
                    </Avatar>

                    <MenuDropdown
                      user={this.state.userData.email}
                      buttonEndIcon={
                        <Icon className="material-symbols-outlined">
                          expand_more
                        </Icon>
                      }
                      buttonText={
                        <Typography component="span" color="inherit" noWrap>
                          {this.state.userData.firstName}
                        </Typography>
                      }
                      callbackForgot={this.callbackForgot}
                    />

                    <ProfileImageUploadModal
                      isOpen={this.state.showProfileModal}
                      onClose={this.handleCloseModal}
                      currentImage={this.state.additionalUserData?.profilePictureUri}
                      userName={this.state.userData?.name || ""}
                      onSave={this.handleSaveProfileImage}
                    />
                  </>
                ) : (
                  ""
                )}
              </Toolbar>
            </AppBar>
            {/* END HEADER */}

            {this.state.showHotelSelection ? (
              <main
                className="main_admin viewListGeneralContainer"
                style={{
                  padding: 30,
                  overflowY: "auto",
                  height: "calc(100vh)",
                }}
              >
                <div className="app_bar_spacer" />
                <Grid container className="main_admin_hotels">
                  <Grid
                    item
                    xs={12}
                    md={8}
                    style={{ margin: "0 auto" }}
                    alignItems="center"
                  >
                    <Typography variant="h6">Accounts</Typography>
                    <Typography variant="subtitle1">
                      Select the account you want to manage.
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={8} style={{ margin: "0 auto" }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="Search..."
                      value={this.state.searchText} // Links value to state
                      onChange={this.handleSearchChange} // Updates the status on every change
                      style={{ marginBottom: "16px" }}
                    />
                    <Grid container spacing={2}>
                      {this.state.listHotels
                        .filter((hotel) =>
                          hotel.accountName
                            .toLowerCase()
                            .includes(this.state.searchText.toLowerCase())
                        )
                        .map((hotel) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={hotel.accountUuid}
                          >
                            <Button
                              variant="contained"
                              fullWidth
                              color="primary"
                              onClick={() => this.handleHotelSelect(hotel)}
                              style={{
                                textTransform: "none",
                                padding: "16px",
                                backgroundColor: "#6C6C6C",
                              }}
                            >
                              <b>{hotel.accountName} </b>
                            </Button>
                          </Grid>
                        ))}
                    </Grid>
                  </Grid>
                </Grid>
              </main>
            ) : (
              <>
                {/* START SIDEBAR */}
                {this.state.showSidebar && <SidebarNavigation />}
                {/* END SIDEBAR */}
                <main className="main_admin">
                  <div className="app_bar_spacer" />

                  {this.state.responseForgot !== "" && (
                    <Collapse in={this.state.openAlert}>
                      <Container maxWidth={false} className="container pb-0">
                        <Alert
                          severity="info"
                          variant="filled"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                this.collapseAlert(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {this.state.responseForgot}
                        </Alert>
                      </Container>
                    </Collapse>
                  )}

                  <Container
                    fixed={true}
                    disableGutters
                    // maxWidth={false}
                    sx={{
                      width: "100% !important",
                      maxWidth: "100% !important",
                    }}
                    className="container mainLayout_container mainAdminContainer"
                  >
                    <Outlet />
                  </Container>
                </main>
              </>
            )}
          </div>
        </Theme>
      </Fragment >
    );
  }
}

const mapStateToProps = (reducers) => {
  return reducers;
};

const mapDispachToProps = (dispatch) => {
  return {
    getAccountListFiltered: (access, query, page, idUser) =>
      dispatch({ type: "GET_LIST_ACCOUNT_FILTERED", access, query, page, idUser }),
    updateUser: (access, form, id) =>
      dispatch({ type: "UPDATE_USER", access, form, id }),
    resetSagaAnalyticsHighlights: () => dispatch({ type: "RESET_ANALYTICS_HIGHLIGHTS" }),
  };
};
export default connect(mapStateToProps, mapDispachToProps)(MainAdmin);
